import { useQuery } from 'react-query'
import {
  FinancialRecurringFilters,
  FinancialRecurringListResponse,
  FinancialRecurringTransaction,
} from '../../Interfaces/financialRecurring'
import { api } from '../api'

const toNumber = (value: unknown): number => {
  if (value === null || value === undefined) {
    return 0
  }

  const numericValue = typeof value === 'string' ? Number(value.replace(',', '.')) : Number(value)
  return Number.isNaN(numericValue) ? 0 : numericValue
}

export async function getRecurringTransactions(
  filters: FinancialRecurringFilters,
): Promise<FinancialRecurringListResponse> {
  const params = {
    ...filters,
    with: 'client',
    nature:
      filters.ui_nature === 'RECEITAS' || filters.ui_nature === 'DESPESAS'
        ? (filters.ui_nature as 'RECEITAS' | 'DESPESAS')
        : 'TODOS',
    payment_method_id: filters.payment_method_id || undefined,
  }

  const { data } = await api.get<FinancialRecurringListResponse>('financial/transactions', { params })

  const normalized: FinancialRecurringTransaction[] = data.data.map((item) => ({
    ...item,
    id: Number(item.id),
    financial_transaction_id:
      item.financial_transaction_id !== undefined && item.financial_transaction_id !== null
        ? Number(item.financial_transaction_id)
        : item.financial_transaction_id,
    recurring_transaction_id:
      item.recurring_transaction_id !== undefined && item.recurring_transaction_id !== null
        ? Number(item.recurring_transaction_id)
        : item.recurring_transaction_id ?? null,
    value: toNumber(item.value),
    interest_value: toNumber(item.interest_value),
    paid_value: toNumber(item.paid_value),
  }))

  return {
    data: normalized,
    meta: data.meta,
  }
}

export function useFinancialTransactions(filters: FinancialRecurringFilters) {
  return useQuery(['financial-transactions', filters], () => getRecurringTransactions(filters), {
    keepPreviousData: true,
    staleTime: 1000 * 30,
  })
}

export const useRecurringTransactions = useFinancialTransactions
